module.exports = __webpack_public_path__ + "static/media/card_sea_anemones.bc2e14b7.jpg";